export default {
  ips: null,
  ip: null,
  removedIPs: null
};
